const KEY = "vishu_ref";
const LEGACY_KEY = "vishu_ref_code";
const WINDOW_MS = 7 * 24 * 60 * 60 * 1000;

export function saveReferral(code) {
  localStorage.removeItem(LEGACY_KEY);
  localStorage.setItem(KEY, JSON.stringify({ code: code.toUpperCase(), ts: Date.now() }));
}

// Returns the referral code only if the link was clicked within the last 7 days
export function getActiveReferral() {
  localStorage.removeItem(LEGACY_KEY);
  try {
    const { code, ts } = JSON.parse(localStorage.getItem(KEY) || "null") || {};
    if (code && ts && Date.now() - ts <= WINDOW_MS) return code;
  } catch { /* ignore malformed */ }
  localStorage.removeItem(KEY);
  return "";
}
